import axios from 'axios';
const adminURL = process.env.VUE_APP_ADMIN_URL;

export default class EjecutivosService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getAll(all = false) {
    try {
      const params = all ? '?all=true' : '';
      const res = await axios.get(`${adminURL}/useradmin${params}`, { headers: this.getHeaders() });
      return { status: 'ok', data: res.data.data };
    } catch (e) { return { status: 'error' }; }
  }

  static async toggleStatus(id) {
    try {
      await axios.patch(`${adminURL}/useradmin/${id}/status`, {}, { headers: this.getHeaders() });
      return { status: 'ok' };
    } catch (e) { return { status: 'error' }; }
  }

  /**
   * Creates an administrator. The backend generates the password, emails it,
   * and derives `createdBy` from the caller's session — the client never sends it.
   */
  static async create({ name, surname, email }) {
    try {
      await axios.post(`${adminURL}/useradmin`, { name, surname, email }, { headers: this.getHeaders() });
      return { status: 'ok' };
    } catch (e) {
      const data = e?.response?.data ?? {};
      return { status: 'error', code: data.code ?? null, message: data.message ?? null };
    }
  }
}
